import { render, staticRenderFns } from "./Reporte.vue?vue&type=template&id=67457c37&scoped=true&"
import script from "./Reporte.vue?vue&type=script&lang=js&"
export * from "./Reporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67457c37",
  null
  
)

export default component.exports